module.exports = __webpack_public_path__ + "fonts/NotoSansGeorgian-Medium.991fc6f0.eot";